export const GOOGLE_MAPS_API_KEY = "AIzaSyD2xW0cH_eqGiTUWzttBPQY_Kgk175017o";
